import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-facing-decorator';
import axios from "axios";
import { ElSwitch } from 'element-plus';
import Icon from "@/components/icon/Icon.vue";
import IconButton from "@/components/buttons/IconButton.vue";
import StandardButton from "@/components/buttons/StandardButton.vue";
import WSelectAdvanced from "@/components/form/w-select-advanced.vue";
import SpeachManageTranslationsModal from "@/components/translation/SpeachManageTranslationsModal.vue";
import ConfirmDialog from "@/components/dialogs/ConfirmDialog.vue";
let SpeachTranslationSettings = class SpeachTranslationSettings extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "speachId", void 0);
    _defineProperty(this, "transcriptEnabled", void 0);
    _defineProperty(this, "visionEnabled", void 0);
    _defineProperty(this, "originalLang", "");
    _defineProperty(this, "officialLanguages", []);
    _defineProperty(this, "allLanguages", []);
    _defineProperty(this, "activeLanguages", []);
    _defineProperty(this, "allTranslations", {
      speach: {
        sourceMap: {},
        translations: {}
      },
      weet: {}
    });
    _defineProperty(this, "weetMappings", {});
    _defineProperty(this, "selectedToAdd", []);
    _defineProperty(this, "editModalVisible", false);
    _defineProperty(this, "modalTargetLanguages", []);
    _defineProperty(this, "loadingData", false);
    _defineProperty(this, "translating", false);
    _defineProperty(this, "togglingLang", null);
    _defineProperty(this, "deleteDialogVisible", false);
    _defineProperty(this, "pendingDeleteLang", null);
    _defineProperty(this, "deletingLang", null);
  }
  mounted() {
    this.fetchOfficialLangs();
    this.fetchData();
  }
  fetchOfficialLangs() {
    axios.get('/api/v2/translations/languages').then(resp => {
      this.officialLanguages = resp.data || [];
    }).catch(err => console.error("Failed to fetch official languages", err));
  }
  async fetchData() {
    this.loadingData = true;
    try {
      const resp = await axios.get(`/api/v2/translations/${this.speachId}/data`);
      const data = resp.data || {};
      this.originalLang = (data.originalLanguage || "").toUpperCase();
      this.weetMappings = data.weetMappings || {};
      this.allTranslations = {
        speach: {
          sourceMap: data.speach && data.speach.sourceMap || {},
          translations: data.speach && data.speach.translations || {}
        },
        weet: data.weet || {}
      };
      const langs = data.languages || [];
      this.allLanguages = langs.filter(l => l.toUpperCase() !== this.originalLang).map(l => l.toUpperCase());
      const active = data.activeTranslationsLanguages || [];
      this.activeLanguages = active.map(l => l.toUpperCase());
    } catch (err) {
      console.error("Failed to fetch translation data", err);
    } finally {
      this.loadingData = false;
    }
  }
  get languageDropdownOptions() {
    return this.officialLanguages.filter(opt => (opt.value || '').toUpperCase() !== this.originalLang).map(opt => {
      const v = (opt.value || '').toUpperCase();
      return {
        value: opt.value,
        label: opt.label,
        disabled: this.allLanguages.includes(v)
      };
    });
  }
  get languageDropdownSelected() {
    return this.selectedToAdd;
  }
  get canAdd() {
    return Array.isArray(this.selectedToAdd) && this.selectedToAdd.length > 0 && !this.translating;
  }
  onSelectionChange(values) {
    const upper = (values || []).map(v => (v || '').toUpperCase());
    // Anything not already in allLanguages is "to add"
    this.selectedToAdd = upper.filter(v => !this.allLanguages.includes(v));
  }
  labelFor(code) {
    const found = this.officialLanguages.find(l => (l.value || '').toUpperCase() === code.toUpperCase());
    return found ? found.label : code;
  }
  isActive(lang) {
    return this.activeLanguages.includes(lang.toUpperCase());
  }
  get perLangStats() {
    const stats = {};
    for (const lang of this.allLanguages) {
      stats[lang] = this.computeStatsForLang(lang);
    }
    return stats;
  }
  computeStatsForLang(lang) {
    let total = 0;
    let done = 0;
    const speachSource = this.allTranslations.speach.sourceMap;
    const speachTr = this.allTranslations.speach.translations;
    for (const sourceKey of Object.keys(speachSource)) {
      total++;
      const tKey = this.getTranslationKey(lang, sourceKey);
      const val = speachTr[tKey];
      if (val && String(val).trim().length > 0) done++;
    }
    for (const videoId of Object.keys(this.allTranslations.weet)) {
      const w = this.allTranslations.weet[videoId];
      for (const sourceKey of Object.keys(w.sourceMap)) {
        total++;
        const tKey = this.getWeetTranslationKey(w.translations, lang, sourceKey);
        const val = w.translations[tKey];
        if (val && String(val).trim().length > 0) done++;
      }
    }
    const missing = total - done;
    const donePercent = total > 0 ? Math.round(done / total * 100) : 0;
    return {
      total,
      done,
      missing,
      donePercent
    };
  }
  get totalMissing() {
    return this.allLanguages.reduce((sum, l) => sum + (this.perLangStats[l]?.missing || 0), 0);
  }
  get totalDonePercent() {
    let total = 0;
    let done = 0;
    for (const l of this.allLanguages) {
      total += this.perLangStats[l]?.total || 0;
      done += this.perLangStats[l]?.done || 0;
    }
    return total > 0 ? Math.round(done / total * 100) : 0;
  }
  get hasMissingTranslations() {
    return this.totalMissing > 0;
  }
  async onAddLanguages() {
    if (!this.canAdd) return;
    const newLangs = this.selectedToAdd.map(l => l.toUpperCase()).filter(l => !this.allLanguages.includes(l));
    if (!newLangs.length) return;
    this.translating = true;
    try {
      const startResp = await axios.post(`/api/v2/translations/${this.speachId}/auto-translate`, {
        originalLanguage: this.originalLang,
        languages: newLangs
      });
      const jobID = startResp.data;
      if (jobID) await this.pollJob(jobID);
      this.selectedToAdd = [];
      await this.fetchData();
    } catch (err) {
      console.error("Failed to auto-translate new languages", err);
    } finally {
      this.translating = false;
    }
  }
  async onTranslateWithAI() {
    if (!this.activeLanguages.length) return;
    this.translating = true;
    try {
      const startResp = await axios.post(`/api/v2/translations/${this.speachId}/auto-translate`, {
        originalLanguage: this.originalLang,
        languages: this.activeLanguages
      });
      const jobID = startResp.data;
      if (jobID) await this.pollJob(jobID);
      await this.fetchData();
    } catch (err) {
      console.error("Failed to auto-translate active languages", err);
    } finally {
      this.translating = false;
    }
  }
  async onToggleActive(lang, checked) {
    const upper = lang.toUpperCase();
    const nextActive = checked ? Array.from(new Set([...this.activeLanguages, upper])) : this.activeLanguages.filter(l => l !== upper);
    this.togglingLang = upper;
    try {
      const resp = await axios.put(`/api/v2/translations/${this.speachId}/active-languages`, {
        languages: nextActive
      });
      const persisted = resp.data || [];
      this.activeLanguages = persisted.map(l => l.toUpperCase());
    } catch (err) {
      console.error("Failed to update active languages", err);
    } finally {
      this.togglingLang = null;
    }
  }
  openManageModal() {
    this.modalTargetLanguages = [...this.allLanguages];
    this.editModalVisible = true;
  }
  openManageModalForLang(lang) {
    this.modalTargetLanguages = [lang.toUpperCase()];
    this.editModalVisible = true;
  }
  askDeleteLang(lang) {
    this.pendingDeleteLang = lang.toUpperCase();
    this.deleteDialogVisible = true;
  }
  cancelDelete() {
    this.deleteDialogVisible = false;
    this.pendingDeleteLang = null;
  }
  async confirmDelete() {
    const lang = this.pendingDeleteLang;
    this.deleteDialogVisible = false;
    if (!lang) return;
    this.deletingLang = lang;
    try {
      await axios.delete(`/api/v2/translations/${this.speachId}/language/${encodeURIComponent(lang)}`);
      await this.fetchData();
    } catch (err) {
      console.error("Failed to delete translation language", err);
    } finally {
      this.deletingLang = null;
      this.pendingDeleteLang = null;
    }
  }
  async onTranslationsSaved() {
    await this.fetchData();
  }
  async pollJob(jobID) {
    const maxAttempts = 60;
    for (let i = 0; i < maxAttempts; i++) {
      try {
        const resp = await axios.get(`/api/v2/translations/job/${jobID}`);
        if (resp.data === "OK") return;
        if (resp.data === "ERROR") throw new Error("Translation job failed");
        await new Promise(r => setTimeout(r, 5000));
      } catch (e) {
        console.error("Polling error", e);
        throw e;
      }
    }
    throw new Error("Translation job timed out");
  }
  getTranslationKey(targetLang, sourceKey) {
    const parts = sourceKey.split('.');
    let suffix = sourceKey;
    if (parts.length > 1 && parts[0].length >= 2 && parts[0].length <= 5) {
      suffix = parts.slice(1).join('.');
    }
    const targetKey = targetLang.toUpperCase() + '.' + suffix;
    const map = this.allTranslations.speach.translations;
    const match = Object.keys(map).find(k => k.toUpperCase() === targetKey.toUpperCase());
    return match || targetKey;
  }
  getWeetTranslationKey(weetTranslations, targetLang, sourceKey) {
    const parts = sourceKey.split('.');
    let suffix = sourceKey;
    if (parts.length > 1 && (parts[0].length === 2 || parts[0].length === 5)) {
      suffix = parts.slice(1).join('.');
    }
    const targetKey = targetLang.toUpperCase() + "." + suffix;
    if (weetTranslations[targetKey]) return targetKey;
    const existingKeys = Object.keys(weetTranslations);
    const insensitive = existingKeys.find(k => k.toUpperCase() === targetKey.toUpperCase());
    if (insensitive) return insensitive;
    const truncated = existingKeys.find(k => {
      if (!k.toUpperCase().startsWith(targetLang.toUpperCase() + ".")) return false;
      const tp = targetKey.split('.');
      const kp = k.split('.');
      if (tp.length !== kp.length) return false;
      for (let i = 0; i < tp.length - 1; i++) {
        if (tp[i].toUpperCase() !== kp[i].toUpperCase()) return false;
      }
      const idPart = kp[kp.length - 1];
      return idPart.length === 15 && targetKey.includes(idPart);
    });
    return truncated || targetKey;
  }
};
__decorate([Prop({
  required: true
})], SpeachTranslationSettings.prototype, "speachId", void 0);
__decorate([Prop({
  default: 'false'
})], SpeachTranslationSettings.prototype, "transcriptEnabled", void 0);
__decorate([Prop({
  default: false
})], SpeachTranslationSettings.prototype, "visionEnabled", void 0);
SpeachTranslationSettings = __decorate([Component({
  components: {
    Icon,
    IconButton,
    StandardButton,
    WSelectAdvanced,
    SpeachManageTranslationsModal,
    ConfirmDialog,
    ElSwitch
  }
})], SpeachTranslationSettings);
export default SpeachTranslationSettings;